export enum tabs {
  PHOTOS,
  NOTES,
}

export const views = {
  GALLERY: false,
  SINGLE: true,
};
